import { render, staticRenderFns } from "./cusAuthList.vue?vue&type=template&id=9b8000ca&scoped=true"
import script from "./cusAuthList.vue?vue&type=script&lang=js"
export * from "./cusAuthList.vue?vue&type=script&lang=js"
import style0 from "./cusAuthList.vue?vue&type=style&index=0&id=9b8000ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8000ca",
  null
  
)

export default component.exports